import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Unstable_Grid2/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/Agent/Client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/AppBar/Large/Actions/BackButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/Button/Share.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/nawar/dev/app/src/component/Card/Paper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/Star/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/docs/Content/Reader/Article/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/docs/Content/Reader/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/docs/Content/Reader/Support/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContentSwitch"] */ "/home/nawar/dev/app/src/view/docs/Content/Reader/Support/Related/Content/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/docs/Content/Reader/TTS/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/docs/Content/Tabs/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageHooksDocs"] */ "/home/nawar/dev/app/src/view/docs/Hooks.js");
